import { useLocation } from "react-router";
import { WorkspaceEntry } from "./OnboardingEntry";

/**
 * Workspace-less deep links (`/channels`, `/inbox`, `/settings/...`) are not routes of their own:
 * once signed in they go to the same path inside the current-or-last workspace, keeping the
 * query string and hash. `WorkspaceEntry` resolves the workspace (or shows the creation page).
 */
export const WORKSPACELESS_PREFIXES = [
  "channels",
  "inbox",
  "conversations",
  "flows",
  "contacts",
  "settings",
  "broadcasts",
] as const;

export function WorkspacelessRedirect() {
  const { pathname, search, hash } = useLocation();
  return <WorkspaceEntry target="home" suffix={`${pathname}${search}${hash}`} />;
}
